import { useEffect } from 'react';

import {
  useJobDescriptionsFromExternalWebsitesActions
} from './JobDescriptionsFromExternalWebsitesContext';

import {
  getJobDescriptionsFromExternalWebsites,
} from './restApi';

const JobDescriptionsFromExternalWebsitesLoader = () => {
  const { initializeState, onResponse, onError } = useJobDescriptionsFromExternalWebsitesActions();

  useEffect(() => {
    initializeState();
  }, []);

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    getJobDescriptionsFromExternalWebsites({
      onResponse,
      onError,
      body: {
        authenticityToken,
        pageNumber: 1,
      },
    });
  }, []);

  return null;
};

export default JobDescriptionsFromExternalWebsitesLoader;